import { DESKTOP_WIDTH } from './constants';

export const desktopStyleToAdd = `@media (min-width: ${DESKTOP_WIDTH}px) {
  max-width: 512px;
}`;

export const desktopMediaQuery = `@media (min-width: ${DESKTOP_WIDTH}px)`;
export const mobileMediaQuery = `@media (max-width: ${DESKTOP_WIDTH - 1}px)`;

export const hoverPointerOnDesktop = `
${desktopMediaQuery} {
  &:hover {
    cursor: pointer;
  }
}`;

export const hoverTranslateOnDesktop = `
${desktopMediaQuery} {
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-2px);
  }
}`;

export const getIsOnDesktop = () => window.innerWidth >= DESKTOP_WIDTH;

export const imageHoverAnimationInFeed = `
${desktopMediaQuery} {
  transition: all 0.3s ease;
  &:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
  }
}
`;

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent,
);

export const generateLoremIpsum = (length: number) => {
  const fullLoremIpsum =
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur';
  // return length amount of words
  return fullLoremIpsum.split(' ').slice(0, length).join(' ');
};

const FEED_INDVD_IMAGE_URL_PART = 'feed?id=';
const CHAT_URL_PART = '/chat/conversation';
const CHARACTER_CREATION_URL_PART = 'create/character';

/**
 * Determines whether the top bar should be hidden based on the current URL.
 * @returns {boolean} `true` if the top bar should be hidden, `false` otherwise.
 */
export const shouldHideTopBar = () => {
  const url = window.location.href;
  const urls = [FEED_INDVD_IMAGE_URL_PART, CHAT_URL_PART];
  return urls.some((urlPart) => url.includes(urlPart)) && !getIsOnDesktop();
};

export const shouldMinimizeBottomNavigationBar = () => {
  const url = window.location.href;
  const urls = [CHAT_URL_PART, CHARACTER_CREATION_URL_PART];
  return urls.some((urlPart) => url.includes(urlPart)) && !getIsOnDesktop();
};